import RecipeOverviewContainer from './recipe_overview_container'

export default RecipeOverviewContainer
